import { Theme } from '@material-ui/core';
import React, { useState } from 'react';
import Layout from '../../components/Layout';
import { isAuthenticated } from '../../services/Authentification/authentification';
import DepannagePageContent from './Content';

interface Props {
  classes?: any;
}
const DepannagePage = (props: Props) => {
  const { classes } = props;
  const authenticated = isAuthenticated();

  const [theme, setTheme] = useState<Theme>();

  return (
    <Layout authenticated={authenticated} passTheme={setTheme}>
      <DepannagePageContent theme={theme}></DepannagePageContent>
    </Layout>
  );
};

export default DepannagePage;
